import React, {lazy, Suspense} from "react";
import {useDispatch, useSelector} from "react-redux";
import {
    getSelectedSearchTab,
    setSelectedSearchTab,
    resetGeoSearchQuery,
    resetNameSearchQuery,
    resetNameSearchResults,
    resetSelectedFilters,
    resetCurrentMapBounds,
    resetClickedRestaurant
} from "../../../../store/slices/restaurantSearchSlice";

import "./SearchTabs.scss";

import ComponentLoader from "../../../ComponentLoader/ComponentLoader";
import {Event} from "../../../GaTracking/GaTracking";
const GeoSearchTab = lazy(() => import("../GeoSearchTab/GeoSearchTab"));
const NameSearchTab = lazy(() => import("../NameSearchTab/NameSearchTab"));

export const TABS = {
    GEO_SEARCH: 'geo',
    NAME_SEARCH: 'name'
};
export const DEFAULT_TAB = TABS.GEO_SEARCH;

const SearchTabs = (props) => {

    const {t} = props;

    const dispatch = useDispatch();

    const selectedSearchTab = useSelector(getSelectedSearchTab) || DEFAULT_TAB;

    const onTabClick = (tab) => {
        if(tab !== selectedSearchTab) {
            dispatch(resetGeoSearchQuery());
            dispatch(resetNameSearchQuery());
            dispatch(resetNameSearchResults());
            dispatch(resetSelectedFilters());
            dispatch(resetCurrentMapBounds());
            dispatch(resetClickedRestaurant());
            dispatch(setSelectedSearchTab(tab));
        }
    }

    return (
        <>
            <ul className="idg-restaurant-search-tabs">
                <li
                    className={selectedSearchTab === TABS.GEO_SEARCH ? 'is-selected' : ''}
                >
                    <button
                        onClick={() => { onTabClick(TABS.GEO_SEARCH); Event("Tab mappa", "Click", "Dove vuoi mangiare?"); }}
                    >
                        {t('idg.restaurantSearch.byGeo')}
                    </button>
                </li>
                <li
                    className={selectedSearchTab === TABS.NAME_SEARCH ? 'is-selected' : ''}
                >
                    <button
                        onClick={() => { onTabClick(TABS.NAME_SEARCH); Event("Tab mappa", "Click", "Cerchi un ristorante?"); }}
                    >
                        {t('idg.restaurantSearch.byName')}
                    </button>
                </li>
            </ul>
            <div className="idg-restaurant-search-tabs-content">

                { (selectedSearchTab === TABS.GEO_SEARCH) &&
                <Suspense fallback={<ComponentLoader />}>
                    <GeoSearchTab t={t} />
                </Suspense>
                }

                { (selectedSearchTab === TABS.NAME_SEARCH) &&
                <Suspense fallback={<ComponentLoader />}>
                    <NameSearchTab t={t} />
                </Suspense>
                }
            </div>
        </>
    )
}

export default SearchTabs;
